import { VTextField } from 'vuetify/lib/components/VTextField';

var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(VTextField,_vm._b({attrs:{"label":_vm.$t('Avalara Entity Use Code'),"hide-details":"auto","outlined":""},model:{value:(_vm.avalaraEntityUseCode),callback:function ($$v) {_vm.avalaraEntityUseCode=$$v},expression:"avalaraEntityUseCode"}},'v-text-field',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }